import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';

import css from '../css/recommended-next-steps.m.css';

export interface RecommendedActionProperties {
	title: string;
	buttonLabel: string;
	onclick(): void;
	onkeydown(event: KeyboardEvent): void;
}

const factory = create({
	theme
}).properties<RecommendedActionProperties>();

export const RecommendedAction = factory(({ properties, middleware: { theme } }) => {
	const { noTable } = theme.classes(css);
	const { title = '', buttonLabel = '', onclick, onkeydown } = properties();
	return v('div', { classes: [noTable] }, [
		v('div', {}, [title]),
		v(
			'div',
			{
				role: 'button',
				classes: [css.button],
				tabIndex: 0,
				onclick: () => onclick(),
				onkeydown: (event: KeyboardEvent) => onkeydown(event)
			},
			[buttonLabel]
		)
	]);
});

export default RecommendedAction;
